import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CloseSquare from "../assets/images/svg/close-square.svg";
import LogoSvg from "../assets/images/svg/logo.png";
import LogoSvg2 from "../assets/images/svg/logo2.png";


const FixHeader = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [scrolled, setScrolled] = useState(false);
    

     const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    // Fixed Header
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [isOverlayVisible, setOverlayVisible] = useState(false);

    useEffect(() => {
        const offcanvasElement = document.getElementById("offcanvasExample");

        const handleShow = () => setOverlayVisible(true);
        const handleHide = () => setOverlayVisible(false);

        if (offcanvasElement) {
            offcanvasElement.addEventListener("show.bs.offcanvas", handleShow);
            offcanvasElement.addEventListener("hide.bs.offcanvas", handleHide);
        }

        return () => {
            if (offcanvasElement) {
                offcanvasElement.removeEventListener("show.bs.offcanvas", handleShow);
                offcanvasElement.removeEventListener("hide.bs.offcanvas", handleHide);
            }
        };
    }, []);

    return (
        <>
            {/* <!-- ====================================== Header ===================================== --> */}
            <header id="top-navbar" className={`top-navbar ${scrolled ? 'active' : ''}`}>
                <div className="container">
                    <div className="wrapper">
                        <div onClick={() => navigate("/")} className="brand">
                            <img src={LogoSvg} alt="logo" />
                        </div>

                        <div
                            className="burger"
                            id="burger"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasExample"
                        >
                            <span className="burger-line"></span>
                            <span className="burger-line"></span>
                            <span className="burger-line"></span>
                        </div>

                        <nav className="navbar" id="navbar">
                            <div className="side-menu-logo">
                                <div onClick={() => navigate("/")} className="brand">
                                    <img src={LogoSvg2} alt="logo" />
                                </div>
                            </div>

                            <ul className="menu" id="menu">
                                {/* HOME */}
                                <li className={`menu-item ${location.pathname === "/" ? "active" : ""}`}>
                                    <span
                                        className="menu-link menu-link-single-pg"
                                        onClick={() => scrollToSection("topo")}
                                    >
                                        Home
                                    </span>
                                </li>

                                {/* SOBRE */}
                                <li className={`menu-item ${location.pathname === "/about" ? "active" : ""}`}>
                                    <span
                                        className="menu-link menu-link-single-pg"
                                        onClick={() => scrollToSection("sobre")}
                                    >
                                        Sobre
                                    </span>
                                </li>

                                {/* SERVIÇOS */}
                                <li className={`menu-item ${location.pathname === "/" ? "active" : ""}`}>
                                    <span
                                        className="menu-link menu-link-single-pg"
                                        onClick={() => scrollToSection("servicos")}
                                    >
                                        Serviços
                                    </span>
                                </li>

                                {/* CONTATO */}
                                <li className={`menu-item ${location.pathname === "/" ? "active" : ""}`}>
                                    <span
                                        className="menu-link menu-link-single-pg"
                                        onClick={() => window.open('https://wa.me/552731910677', '_blank')}
                                    >
                                        Contato
                                    </span>
                                </li>
                            </ul>
                        </nav>

                        <div className="header-button">
                            <div className="button button1" data-text="WhatsApp" onClick={() =>
                            window.open('https://wa.me/552731910677', '_blank')}>
                                <span>WhatsApp</span> 
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* <!-- ====================================== Mobile Menu ===================================== --> */}
            {/* Overlay */}
            {isOverlayVisible && <div className="custom-overlay"></div>}

            <div
                className="offcanvas offcanvas-start side-menu-offcanvas-main"
                tabIndex="-1"
                id="offcanvasExample"
                aria-labelledby="offcanvasExampleLabel"
            >
                <div className="offcanvas-header">
                    <div className="offcanvas-title" id="offcanvasExampleLabel">
                        <img src={LogoSvg} alt="logo" />
                    </div>
                    <img
                        className="close-square"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        src={CloseSquare}
                        alt="close-square"
                    />
                </div>

                <div className="offcanvas-body">
                    <div className="accordion" id="accordionExample">
                        {/* HOME */}
                        <div className="accordion-item">
                            <div className="accordion-header side-menu-accordion-item">
                                <span onClick={() =>  scrollToSection("topo")}>Home</span>
                            </div>
                        </div>

                        {/* SOBRE */}
                        <div className="accordion-item">
                            <div className="accordion-header side-menu-accordion-item">
                                <span onClick={() =>  scrollToSection("sobre")}>Sobre</span>
                            </div>
                        </div>

                        {/* SERVIÇOS */}
                        <div className="accordion-item">
                            <div className="accordion-header side-menu-accordion-item">
                                <span onClick={() =>  scrollToSection("servicos")}>Serviços</span>
                            </div>
                        </div>

                        {/* CONTATO */}
                        <div className="accordion-item">
                            <div className="accordion-header side-menu-accordion-item">
                                <span onClick={() =>  window.open('https://wa.me/552731910677', '_blank')}>Contato</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FixHeader;
